import * as React from 'react'

export const useInitialValues = (getInitialValues: () => Promise<any>, entity: any, deps?: any) => {
  const [initialValues, setInitialValues] = React.useState({})

  React.useEffect(() => {
    getInitialValues().then(setInitialValues)
  }, [entity, deps])

  return initialValues
}
